import createIcon from '../../createIcon';

/**
 * @component @name HorizontalSplit
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxOUgyMVYxM0gzVjE5Wk0zIDExSDIxVjlIM1YxMVpNMyA1VjdIMjFWNUgzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HorizontalSplit = createIcon('HorizontalSplit', [
  ['path', { d: 'M3 19H21V13H3V19ZM3 11H21V9H3V11ZM3 5V7H21V5H3Z', key: '97c6rg' }],
]);

export default HorizontalSplit;
